import { ADD_ANNOUNCEMENT } from '../../constants';

const initialState = {
  loading: false,
  data: [],
  error: {},
};

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case ADD_ANNOUNCEMENT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ADD_ANNOUNCEMENT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case ADD_ANNOUNCEMENT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
};
